export default __webpack_public_path__ + "static/media/hexagon-gold.84c9896c.svg";